import { useContext } from 'react';
import { MtgContext } from '../hoc/MtgProvider';

export function useMtg() {
	const context = useContext(MtgContext);
	if (context === null) {
		throw new Error('useMtg must be used within a MtgProvider');
	}
	return context;
}
